import { apiPaymentTypes } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = 'payment-types';

const config = [{ actionType: 'getAll', apiPath: apiPaymentTypes, method: get, actionParams: { limit: 0 } }];

export const { getAll } = createThunks(typePrefix, config);
